<template>
  <div class="editor">
    <el-button
      v-if="isWirelessDesc"
      style="margin-bottom: 10px;"
      @click="importPCdesc">导入电脑端描述</el-button>
    <el-button
      v-if="showImportImages"
      style="margin-bottom: 10px;"
      @click="importImages">导入电脑端宝贝图片</el-button>
    <Editor
      :id="key"
      :ref="key"
      :limitImgSize="1 * 1024 * 1024"
      :value="tjbForm[key]"
      :menus="menus"
      @change="onChange"
      @fullScreenChange="editorFullScreenChange" />
  </div>
</template>

<script>
import {editor_mixin} from '@/components/Editor/index.js'
import storeMixins from '../store-mixins'
export default {
  mixins: [storeMixins, editor_mixin],
  props: ["props"],
  computed: {
    key() {
      return this.props.name
    },
    isWirelessDesc() {
      return this.props.name === 'wirelessDesc'
    },
    showImportImages() {
      return ['wirelessDesc', 'desc'].includes(this.props.name)
    },
    menus() {
      // 手机端只允许上传图片
      return this.isWirelessDesc ? ["image"] : []
    }
  },
  watch: {
    editorFormItenClass: {
      immediate: true,
      handler(v) {
        if (!this.$el || !this.$el.parentNode) {
          return ;
        }
        this.fixFullScreenStyle()
      }
    }
  },
  methods: {
    onChange(v) {
      const newFormFields = {}
      newFormFields[this.key] = v
      this.updateTjbForm(newFormFields)
    },
    importPCdesc() {
      this.onChange(this.tjbForm.desc)
      // 初始化好的编辑器需要调用内置方法更新文本
      this.$nextTick(() => {
        this.$refs[this.key].init_text()
      })
    },
    // 倒入宝贝详情图
    importImages() {
      let images = this.tjbForm.images
      if (!images || !images.length) {
        return this.$message.error('电脑端宝贝图片不存在')
      }
      this.$refs[this.key].addImages(images);
      this.$message.success('导入电脑端宝贝图片成功');
    },
    // 修复富文本全屏的及非全屏层级问题
    fixFullScreenStyle() {
      let v = this.editorFormItenClass
      if (v[1].nofull) {
        this.$el.parentNode.style.zIndex = 1
      } else {
        this.$el.parentNode.style.zIndex = ""
      }
    }
  },
  mounted() {
    this.fixFullScreenStyle()
  }
}
</script>

<style lang="scss">
#editor-wirelessDesc {
  .w-e-text {
    text-align: center;
    img {
      display: block;
      margin: 0 auto;
    }
  }
}
</style>